import { React, useEffect, useState, useContext } from "react";
import AnnualAgriculturalProductionDetailsData from "../../../../Components/AnnualAgriculturalProductionDetailsData";
import { MyContextProvider } from "../../../../App";
import axios from "axios";
import { API_URL } from "../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import {
handleUserLevelAccessPermissions,
validateRolesIIP
} from "../../../../Custom/Custom";
import { ToastContainer, toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import messages from '../../../../assets/Messages.json';
import titlesData from '../../../../titles.json';


function AnnualAgriculturalProductionDetails() {

   const [years, setYears] = useState([]);
   const [yearName, setYearName] = useState("");
   const [annualAgrilcultureData, setAnnualAgrilcultureData] = useState([]);
   const [reportType, setReportType] = useState("Q");
   const [payload, setPayload] = useState([]);
   const [buttonAccess, setButtonAccess] = useState({
    userLevel: "",
    roles: "",
    isVisible: false,
  });
  const token = useContext(MyContextProvider).token;
  const decode_token = jwtDecode(token);
  const navigate = useNavigate();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };


  //get next Years 
  const getNextYear = (year) => {
      const nextYear = parseInt(year) + 1;
      return `${year}-${nextYear}`;
  };



  //get Years 
   const getAllYears = () => {
      const currentYear = new Date().getFullYear()-1;
      const yearsArray = [];
      for (let year = currentYear; year >= 2020; year--) {
        yearsArray.push(year);
      }
     return yearsArray;
  };


  useEffect(() => {
    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level);
   const getYearList = () => {
      setYears(getAllYears());
    };

    const userRole = async () => {
      showLoading(true);
      try {
        const role = await validateRolesIIP(decode_token);
        if (role) {
          getYearList();
        } else {
          alert(
            "You are not an authorized user to capture the data for Pricing"
          );
          navigate("/dashboard");
        }
      } catch (error) {
        console.log(error);
        showLoading(false);
      }finally{
        showLoading(false);
      }
    };

    userRole();
  }, []);



  const handleDropdownChange = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "year_name": {
        setYearName(value);
        const postData = {
          baseYear: value,
          reportType: reportType,
        };
        onChangeAnnualAgricultureProductionDetails(postData);
        break;
      }
      case "report_type": {
        setReportType(value);
        if (yearName) {
          const postData = {
            baseYear: yearName,
            reportType: value,
          };
          onChangeAnnualAgricultureProductionDetails(postData);
        }
        break;
      }
      default:
        console.log("switch case are not match");
        break;
    }
  };


  const onChangeAnnualAgricultureProductionDetails = async (postData) => {
    showLoading(true);

    try {
      const response = await axios.post(`${API_URL}api/iip/getIIPAnnualAgriculturalProductionDataFetch`, postData, config);
      if (response.data.status) {
         setAnnualAgrilcultureData(response.data.data.GroupCodes);
         setPayload(response.data.data.payload)
      }
    } catch (error) {
      console.error('Error posting data:', error);
    }finally{
      showLoading(false);
    }

  }


  //handle reset form
  const resetForm=()=>{
     setAnnualAgrilcultureData([]);
     setYearName('');
     setReportType("Q");
   }


   //handle Button click validation
   const handleSaveButtonValidation=()=>{
     if(yearName===''){
        toast.error(messages.YEAR_NAME_MSG, messages.COLOR_RED);
        return false;
        }
        return true;
   }

   const storedLanguage = localStorage.getItem('language');

  return (
    <>
    <GlobalLoading />
    <ToastContainer />
    <div className="container-fluid py-3">
      <div className="card mx-3 mb-3">
        <div className="card-body pb-1">
          <div className="row align-items-center">
          
            <h4 className="page_heading">
            {storedLanguage === 'hi' ? titlesData.hi.IIP_AGRICULTURAL_PRODUCTION_DETAILS : titlesData.en.IIP_AGRICULTURAL_PRODUCTION_DETAILS}
            </h4>

            <div className="row justify-content-center g-3 mt-1 mb-2">
              <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <label className="form-label mb-1">
                  {storedLanguage === 'hi' ? titlesData.hi.YEAR : titlesData.en.YEAR}
                </label>
                <select
                  name="year_name"
                  className="form-select"
                  onChange={handleDropdownChange}
                  value={yearName}
                >
                  <option value="" disabled>
                    Select Year
                  </option>
                  {years &&
                    years.map((ele, index) => (
                      <option key={index} value={getNextYear(ele)}>
                        {getNextYear(ele)}
                      </option>
                    ))}
                </select>
              </div>

              <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <label className="form-label mb-1">Report Type</label>
                <select
                  name="report_type"
                  className="form-select"
                  onChange={handleDropdownChange}
                  value={reportType}
                >
                  <option value="Q">Q</option>
                  <option value="P">P</option>
                  <option value="F">F</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      {annualAgrilcultureData.length > 0 && (
        <div className="card mx-3 mb-3">
          <AnnualAgriculturalProductionDetailsData
            type="AnnualAgriculturalProductionDetails"
            payload={payload}
            config={config}
            resetFormData={resetForm}
            userInfoObject={buttonAccess}
            yearName={yearName}
            reportType={reportType}
            annualAgrilcultureData={annualAgrilcultureData}
          />
        </div>
      )}

    </div>
   </>
  )
}

export default AnnualAgriculturalProductionDetails